export const ENVIRONMENTS = {
  development: 'development',
  staging: 'staging',
  production: 'production',
};
export const APPLE_CLIENT_ID = 'com.raceid.client';

export const GOOGLE_CLIENT_ID_KEYS = {
  development: '156649242304-cdm6fk1rv45m01c8pnb90k8581sq09kb.apps.googleusercontent.com',
  staging: '487308708333-7a73routh6bmi7clslpp0skppd82p5f2.apps.googleusercontent.com',
  production: '327852842123-rqul21g3vort5u7kfcmv8l1ihfff6iml.apps.googleusercontent.com',
};

export const GTM_ID = 'GTM-PTFDK7Z';

/**
 * Pace GA4 property (RaceID.com - GA4)
 */
export const GA_MEASUREMENT_ID = 'G-N8KPPZ7QGJ';

export const AMPLITUDE_KEYS: { [key in Environment]: string } = {
  staging: 'be5e6023609a6e89636f737aa5c5e7e0',
  development: '1eebfa17c165706d78e8c127465146d0',
  production: '5a860a561dec7f4cada8d01b9075c59c',
};

/**
 * Temp GTM container added for the OTILLO organizer  RP-6333
 */
export const GTM_ID_OTILLO = 'GTM-KKX2NT7';

export const IOS_APP_ID = 'se.RaceID.ios://';

/**
 * Intercom id https://www.intercom.com/
 */
export const INTERCOM_APP_ID = 'gdcf2ieg';

/**
 * Stripe publishable API key
 */

export const STRIPE_PUBLIC_KEYS: { [key in Environment]: string } = {
  staging: 'pk_test_51KxVHNLJ5IZBFF4CLs207CviAkqp0yU78i1aC8r8Db6zXGhiuHp1TlTUybymLRGU2mGnFV9olmnVSYk3ggmOwLXo0012PzlTMi',
  development: 'pk_test_51KxTKbCXwdtqnR11HmtK0ArFtaRVXtmggmTsqgm0KpWrvFBi3K5KOJYcR1WITp8TLWl0t4K9CcrVz3FdWmNWQwjZ00jBbsaYkp',
  production: 'pk_live_djO5HIgPHjYpTiMmpRUgrHum00lZoLAQ84',
};

/**
 * Cloudflare Turnstile site key (public value)
 * The development key is Cloudflare's official always-passes test key
 */
export const TURNSTILE_SITE_KEYS: { [key in Environment]: string } = {
  development: '0x4AAAAAAEtoVNxH6POytc_G',
  staging: '0x4AAAAAAEtoVNxH6POytc_G',
  production: '0x4AAAAAAEtqPv0rK47HdrZQ',
};

export const STRIPE_MILES_PUBLIC_KEYS: { [key in Environment]: string } = {
  staging: 'pk_test_51Nnd9lK5ZFtmIMtkzKKiHSq5BP2fRIkAh3XHiIl16tLJ8IXiyEU1lNnvUQMUlakRkag6jV0xCWMMeDN0HjO1wPEZ00S8L5OydF',
  development: 'pk_test_51Nnd9lK5ZFtmIMtkzKKiHSq5BP2fRIkAh3XHiIl16tLJ8IXiyEU1lNnvUQMUlakRkag6jV0xCWMMeDN0HjO1wPEZ00S8L5OydF',
  production: 'pk_live_51NhS1dEvVyHtiYdMWiMFEfsON7UjJxYt6w2ljn9fHwZM7mL0VzeKrzuY0CDhgysJAooy5mhM5WaWEHTIstrlCTHp00E0cKqlmo',
};

export const ADMIN_HOSTS: { [key in Environment]: string } = {
  production: 'https://admin.raceid.com',
  staging: 'https://admin.staging.raceid.com',
  development: 'https://admin.dev.raceid.com',
};

export const CONFIGCAT_SDK_KEYS: { [key in Environment]: string } = {
  production: 'configcat-sdk-1/mQ_dCO20B0qFE88BmJzD-Q/3nZizqBg2U6yWvAqF-xP2g',
  staging: 'configcat-sdk-1/mQ_dCO20B0qFE88BmJzD-Q/6opuvm9c3E2r-f272c5NsA',
  development: 'configcat-sdk-1/mQ_dCO20B0qFE88BmJzD-Q/6opuvm9c3E2r-f272c5NsA',
};

export const API_HOSTS: { [key in Environment]: string } = {
  production: 'https://api.raceid.com',
  staging: 'TBD',
  development: 'https://api.dev.raceid.com',
  // development: 'http://localhost:81',
};

export const ODIN_URLS: { [key in Environment]: string } = {
  production: 'https://auth.pacesports.app',
  staging: 'https://auth-stage.pacesports.raceid.app',
  // development: 'http://localhost:4200',
  development: 'https://auth-dev.pacesports.app',
};

export const PACE_API_HOSTS: { [key in Environment]: string } = {
  production: 'https://api.pacesports.app',
  staging: 'https://api-dev.pacesports.app',
  development: 'https://api-dev.pacesports.app',
};

export const PACE_WEB_HOSTS: { [key in Environment]: string } = {
  production: 'https://www.pacesports.app',
  staging: 'https://www.pacesports.app',
  development: 'https://www.pacesports.app',
};

export const PACE_ADMIN_HOSTS: { [key in Environment]: string } = {
  production: 'https://admin.pacesports.app',
  staging: 'https://admin-staging.pacesports.app',
  development: 'https://admin-dev.pacesports.app',
  // development: 'http://localhost:4200',
};

export const FORCED_END = 'forced_env';
